const SLIDE_SELECTOR = 'slideshow-slide, [data-carousel-card]';
const FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'summary',
    'iframe',
    'video[controls]',
    '[contenteditable]',
    '[tabindex]',
].join(',');
// Remembers the author's tabindex (or its absence) so it can be restored exactly.
const ORIGINAL_TABINDEX_ATTR = 'data-a11y-tabindex';

const fixImageAlts = () => {
    document.querySelectorAll('img:not([alt])').forEach(el => {
        el.setAttribute('alt', '')
    })
}
const fixIframeTitles = () => {
    document.querySelectorAll('iframe[src*="formsite.com"]:not([title]), iframe[src*="formsite.com"][title=""]').forEach(el => {
        el.setAttribute('title', document.querySelector('h1')?.textContent.trim() || document.title);
    })
}

// Hidden slides must not expose focusable content to keyboard users. Only `tabindex` is touched
// (never `inert` / `pointer-events`), so partially visible slides stay clickable and draggable.
/** @param {Element} slide */
const syncSlideFocusability = (slide) => {
    const hidden = slide.getAttribute('aria-hidden') === 'true';

    slide.querySelectorAll(FOCUSABLE_SELECTOR).forEach(el => {
        if (hidden) {
            if (el.hasAttribute(ORIGINAL_TABINDEX_ATTR)) return;
            el.setAttribute(ORIGINAL_TABINDEX_ATTR, el.getAttribute('tabindex') ?? '');
            el.setAttribute('tabindex', '-1');
        } else if (el.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
            const original = el.getAttribute(ORIGINAL_TABINDEX_ATTR);
            if (original) {
                el.setAttribute('tabindex', original);
            } else {
                el.removeAttribute('tabindex');
            }
            el.removeAttribute(ORIGINAL_TABINDEX_ATTR);
        }
    })
}

const fixAccessibility = () => {
    fixImageAlts();
    fixIframeTitles();
    document.querySelectorAll(`:is(${SLIDE_SELECTOR})[aria-hidden]`).forEach(syncSlideFocusability);
}

new MutationObserver((mutations) => {
    let hasAddedNodes = false;

    mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
            const target = /** @type {Element} */ (mutation.target);
            if (target.matches(SLIDE_SELECTOR)) syncSlideFocusability(target);
        } else if (mutation.addedNodes.length) {
            hasAddedNodes = true;
        }
    });

    if (hasAddedNodes) {
        fixAccessibility();
    }
}).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
});

fixAccessibility();
